module.exports = __webpack_public_path__ + "sprstatic/img/jiazai.41e9664.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/jiazai.gif
// module id = /5CX
// module chunks = 2